import defineComponent from 'flight'

function PerformanceMetrics () {
    let pageLoadMetricsRecorded = false;

    this.logPageTimingPerformance = function () {
        if (!pageLoadMetricsRecorded && window.performance) {
            pageLoadMetricsRecorded = true;

            let timing = window.performance.timing;

            let entry = {
                eventName: 'page-performance',
                total_ms: timing.loadEventEnd - timing.navigationStart,
                request_to_response_start_ms: timing.responseStart - timing.requestStart,
                request_total_ms: timing.responseEnd - timing.requestStart,
                unload_ms: timing.unloadEnd - timing.unloadStart,
                dom_loading_ms: timing.domComplete - timing.domLoading,
                onload_ms: timing.loadEventEnd - timing.loadEventStart,
                type: window.performance.navigation.type,
                redirectCount: window.performance.navigation.redirectCount,
                referrer: document.referrer
            };

            if (entry.total_ms > 0) {
                this.trigger(document, 'data:scribe', entry);
            }
        }
    };

    this.after('initialize', function () {
        setTimeout(function () {
            this.logPageTimingPerformance();
        }.bind(this), 1000);
    });
}

export default defineComponent.component(PerformanceMetrics);


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/data/performance-metrics.js